import { DefaultFetchService } from "app/services/fetchService";
import queryString from "query-string";
import type {
    IDeviceDistributionResponseData,
    IDeviceTotalVisitsResponseData,
    IWebRanksResponseData,
    IWebsiteAnalysisTrafficRequestParams,
    RankByMode,
    IEngagementVisitsTable,
    IBaseSingleRequestParams,
} from "app/pages/website-analysis/TrafficAndEngagement/types";

export default class WebsiteAnalysisApiService {
    private static _instance;
    protected fetchService;

    constructor() {
        this.fetchService = DefaultFetchService.getInstance();
    }

    public static getInstance(): WebsiteAnalysisApiService {
        if (!WebsiteAnalysisApiService._instance) {
            WebsiteAnalysisApiService._instance = new WebsiteAnalysisApiService();
        }
        return WebsiteAnalysisApiService._instance;
    }

    public getSingleTotalVisitsData(
        params: IWebsiteAnalysisTrafficRequestParams,
        controller = "TrafficAndEngagement",
    ): Promise<any> {
        return this.fetchService.get(`widgetApi/${controller}/EngagementVisits/SingleMetric`, params);
    }

    public getSingleCompareTotalVisitsData(
        params: IWebsiteAnalysisTrafficRequestParams,
        controller = "TrafficAndEngagement",
    ): Promise<IDeviceTotalVisitsResponseData> {
        return this.fetchService.get(`widgetApi/${controller}/EngagementVisits/Table`, params);
    }

    public getDeviceDistributionData(
        params: IWebsiteAnalysisTrafficRequestParams,
        controller = "WebsiteOverview",
    ): Promise<any> {
        return this.fetchService.get(`widgetApi/${controller}/EngagementDesktopVsMobileVisits/PieChart`, params);
    }

    public getSingleCompareDeviceDistributionData(
        params: IWebsiteAnalysisTrafficRequestParams,
        controller = "WebsiteOverview",
    ): Promise<IDeviceDistributionResponseData> {
        return this.fetchService.get(`widgetApi/${controller}/EngagementDesktopVsMobileVisits/Table`, params);
    }

    public getWebRanksData(params: IWebsiteAnalysisTrafficRequestParams): Promise<any> {
        return this.fetchService.get("api/WidgetKpis/WebRanks/GetSingleMetricData", params);
    }

    public getWebRanksDataForWebsitePerformance(
        params: IWebsiteAnalysisTrafficRequestParams,
        controller = "WebsiteOverview",
    ): Promise<any> {
        return this.fetchService.get(`widgetApi/${controller}/WebRanks/SingleMetric`, params);
    }

    public getEngagementVisitsTableData(params: IBaseSingleRequestParams): Promise<IEngagementVisitsTable> {
        return this.fetchService.get("widgetApi/TrafficGrowthComparison/EngagementVisits/Table", params);
    }

    public getTrafficGrowthComparisonGraphExcelUrl(params: IBaseSingleRequestParams): string {
        const queryStringParams = queryString.stringify({ ...params });
        return `/widgetApi/TrafficGrowthComparison/EngagementVisits/Excel?${queryStringParams}`;
    }

    public getUniqueAndTotalVisitsMonthly(params: IWebsiteAnalysisTrafficRequestParams): Promise<any> {
        return this.fetchService.get("widgetApi/UniqueUsersTraffic/UniqueUsers/SingleMetric", params);
    }

    public getCompareWebRanksData(
        params: IWebsiteAnalysisTrafficRequestParams,
        rankByMode: RankByMode,
        controller = "WebsiteOverview",
    ): Promise<IWebRanksResponseData> {
        return this.fetchService.get(`widgetApi/${controller}/${rankByMode}/Table`, params);
    }
}
